<template>
  <div id="app">
    <!-- <router-view/> -->
    <div v-if="this.isWx">
      <div class="titBox">
        <p class="title">{{ this.name }}专场招聘信息</p>
      </div>

      <div class="box">
        <div class="boxImg">
          <img class="boxImg" src="@/assets/image.png" />
        </div>

        <wx-open-launch-weapp
          id="launch-btn"
          :username="usernameData"
          :path="this.path"
        >
          <script type="text/wxtag-template">
            <style>
              .btn{
                width:70%;
                height:55px;
                margin:80px auto;
                background: #FFBB78;
                box-shadow: 0px 4px 6px 0px rgba(184, 99, 14, 0.33);
                border-radius: 60px;
                font-size: 18px;
                font-family: PingFang-SC-Bold, PingFang-SC;
                font-weight: bold;
                color: #AA3C06;
                text-align:center;
                line-height:55px
              }
            </style>
            <div class="btn">
              点击查看
            </div>
          </script>
        </wx-open-launch-weapp>
      </div>
    </div>

    <div class="othertext" v-else>
      <p :class="ispc?'textp textpActive':'textp '">
        请使用微信打开本页面
      </p>
    </div>
  </div>
</template>

<script>
import { getwxConfig, getName } from './api/request'
export default {
  name: 'App',
  data () {
    return {
      isWx: true,
      configData: '',
      path: '',
      name: '',
      usernameData: '',
      ispc:false,
      type: ''
    }
  },
  created () {
    const os = this.getOs()
    console.log(os);
    if (os.isPc){
      //这是电脑
        this.ispc = true
    }
    if (!this.is_weixn_qq()) {
      console.log('不是微信')
      this.isWx = false
    } else {
      let originWindow = window.location.origin
      if (/yishengyice.com/g.test(originWindow)) {
        document.title = "一生一策"
        this.usernameData = 'gh_50f5f4f87cd7'
      }else if(/jiuyeyuren.com/g.test(originWindow)){
        document.title = "就业育人"
        this.usernameData = 'gh_50f5f4f87cd7'
      } else {
        document.title = "毕业申"
        if( window.location.href.split('?')[1].includes('&')) {
          this.type = window.location.href.split('?')[1].split('&')[1].split('=')[1]
        }
        if (this.type === 'qiye') {
          this.usernameData = 'gh_bd7f15feee12'
        } else {
          this.usernameData = 'gh_5be2df87960d'
        }
      }
      this.isWx = true
      this.getName()
      this.getConfig()
    }
    // this.initConfig()
  },
  methods: {
    is_weixn_qq () {
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else if (ua.match(/QQ/i) === 'qq') {
        return true
      }
      return false
    },
    initConfig () {
      var wx = require('weixin-js-sdk')
      // 通过config接口注入权限验证配置并申请所需开放标签
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
        appId: this.configData.appId, // 必填，公众号的唯一标识
        timestamp: this.configData.timestamp, // 必填，生成签名的时间戳
        nonceStr: this.configData.nonceStr, // 必填，生成签名的随机串
        signature: this.configData.signature, // 必填，签名
        jsApiList: ['wx-open-launch-weapp', 'hideMenuItems'], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      })
      // 通过ready接口处理成功验证
      wx.ready(function () {
        // wx.hideOptionMenu()
        wx.hideMenuItems({
          menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline']
        })
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
      })
      // 通过error接口处理失败验证
      wx.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
      })
    },
    getConfig () {
      if (window.location.href.split('?')[1]) {
        let originWindow = window.location.origin
        if (/yishengyice.com/g.test(originWindow)) {
          if(/page=position_list/g.test(window.location.hash)){
            this.path = `pages/get_position_list/get_position_list?${window.location.href.split('?')[1].split('&')[0]}`
          } else {
            this.path = `pages/index/index?${window.location.href.split('?')[1]}`
          }
        }else if(/jiuyeyuren.com/g.test(originWindow)){
          if(/page=position_list/g.test(window.location.hash)){
            this.path = `pages/get_position_list/get_position_list?${window.location.href.split('?')[1].split('&')[0]}`
          } else {
            this.path = `pages/index/index?${window.location.href.split('?')[1]}`
          }
        }else {
          if( window.location.href.split('?')[1].includes('&')) {
            this.type = window.location.href.split('?')[1].split('&')[1].split('=')[1]
          }
          if (this.type === 'qiye') {
            this.path = `pages/transform_page/transform_page?${window.location.href.split('?')[1]}`
          } else {
            this.path = `pages/index/index?${window.location.href.split('?')[1]}`
          }
        }
        getwxConfig({
          url: window.location.href.split('#')[0],
          middle_type: this.type === 'qiye' ? '5' : ''
        }).then(res => {
          if (res.data.code === 0) {
            this.configData = res.data.data
            this.initConfig()
          }
        })
      }
    },
    getName () {
      if (window.location.href.split('?')[1]) {
        let params = window.location.href.split('?')[1]
        getName({
          id: params.split('=')[1]
        }).then(res => {
          if (res.data.code === 0) {
            this.name = res.data.data.name
          }
        })
      }
    },
    getOs () {
			var ua = navigator.userAgent,
				isWindowsPhone = /(?:Windows Phone)/.test(ua),
				isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
				isAndroid = /(?:Android)/.test(ua),
				isFireFox = /(?:Firefox)/.test(ua),
				isChrome = /(?:Chrome|CriOS)/.test(ua),
				isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox &&
					/(?:Tablet)/.test(ua)),
				isPhone = /(?:iPhone)/.test(ua) && !isTablet,
				isPc = !isPhone && !isAndroid && !isSymbian;
			return {
				isTablet: isTablet,
				isPhone: isPhone,
				isAndroid: isAndroid,
				isPc: isPc
			};
		}
  }
}
</script>

<style scoped>
#app {
  overflow: hidden;
  height: 100%;
  position: absolute;
  left: 0px;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  background: #f3f7ff;
}
.title {
  font-weight: bold;
  color: #20304e;
  font-size: 52px;
  margin: 200px 0 100px 0;
}
.titBox {
  /* width:100%; */
  padding: 0 48px;
}
.boxImg {
  width: 550px;
  height: 390px;
  margin: 0 auto;
}
.box {
  width: 100%;
  /* width: 496px; */
  /* margin:0 auto; */
  /* margin-bottom:144px */
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  /* margin-left:100px */
}

.othertext {
  width: 100%;
  font-size: 32px;
  height: 100vh;
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
}
.textp {
  margin: 400px auto;
}
.textpActive{
  margin: 100px auto;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue